module.exports = __webpack_public_path__ + "media/images/landkit/covers/cover-7-a482565514d96b78619827268df7de76.jpg";